import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Alert extends VuexModule {
  public alertMessage: any = null;
  public typeMessage: any = null;
  public id: any = null;
  public typeUpload: any = null;
  public date: any = null;
  public peakExceptionResponseCode: any = 0;

  @Mutation
  public MutationSetAlertMessage(input: any) {
    this.alertMessage = input.alertMessage ? input.alertMessage : null;
    this.typeMessage = input.typeMessage;
    this.id = input.id ? input.id : null;
    this.typeUpload = input.typeUpload ? input.typeUpload : null;
    this.date = new Date();
    this.peakExceptionResponseCode = input.peakExceptionResponseCode;
  }

  @Action
  public SetAlertMessage(input: any) {
    setTimeout(() => {
      this.context.commit("MutationSetAlertMessage", input);
    }, 50);
  }

  get getAlertMessage(): any {
    return {
      message: this.alertMessage,
      type: this.typeMessage,
      id: this.id,
      typeUpload: this.typeUpload,
      date: this.date,
      peakExceptionResponseCode: this.peakExceptionResponseCode,
    };
  }
}
